import React, { useState } from "react";
import { postContact } from "@/lib/api";
import SeoHead from "@/components/site/SeoHead";
import { toast } from "sonner";

const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", subject: "Hello MELAVI", message: "" });
  const [sending, setSending] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await postContact(form);
      toast.success("Your note is with us. We'll reply within a working day.");
      setForm({ name: "", email: "", subject: "Hello MELAVI", message: "" });
    } catch {
      toast.error("Something went sideways. Please try again in a moment.");
    } finally { setSending(false); }
  };

  return (
    <div className="pt-32 md:pt-40 pb-32" data-testid="contact-page">
      <SeoHead
        title="Contact · write to Meghana & Lallitha"
        description="Questions about a piece, sizing, custom work, or wholesale? Write to the MELAVI studio in Bengaluru — we reply within a working day."
        path="/contact-us"
      />
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-24 grid md:grid-cols-12 gap-16">
        <div className="md:col-span-5">
          <div className="nav-item mb-4">Write to us</div>
          <h1 className="serif text-5xl md:text-6xl leading-[1.02]">Say hello.</h1>
          <p className="mt-8 text-ink/80 leading-relaxed">
            Questions on sizing, gifting, twinning, or a slower-than-usual reply?
            We&rsquo;d love to hear from you. Meghana or Lallitha will reply, personally.
          </p>

          <div className="mt-12 space-y-4 text-sm">
            <div><span className="nav-item block text-ink/50 mb-1">Email</span>Melavi.in@gmail.com</div>
            <div><span className="nav-item block text-ink/50 mb-1">Phone</span>+91 81235 41555</div>
            <div><span className="nav-item block text-ink/50 mb-1">Studio</span>#1991, Ground Floor, 3rd Cross,<br/>20th Main, JP Nagar 2nd Phase,<br/>Bengaluru, Karnataka 560078</div>
            <div><span className="nav-item block text-ink/50 mb-1">Instagram</span>@Melavi_Creations</div>
          </div>
        </div>

        <form onSubmit={onSubmit} className="md:col-span-6 md:col-start-7 space-y-6" data-testid="contact-form">
          {[
            { k: "name", l: "Name", type: "text" },
            { k: "email", l: "Email", type: "email" },
            { k: "subject", l: "Subject", type: "text" },
          ].map((f) => (
            <label key={f.k} className="block">
              <span className="nav-item block mb-2">{f.l}</span>
              <input
                type={f.type}
                required
                value={form[f.k]}
                onChange={(e) => setForm({ ...form, [f.k]: e.target.value })}
                className="w-full bg-transparent hairline-b px-0 py-3 focus:outline-none focus:border-ink"
                data-testid={`contact-${f.k}`}
              />
            </label>
          ))}
          <label className="block">
            <span className="nav-item block mb-2">Message</span>
            <textarea
              rows={6}
              required
              value={form.message}
              onChange={(e) => setForm({ ...form, message: e.target.value })}
              className="w-full bg-transparent hairline-b px-0 py-3 focus:outline-none focus:border-ink resize-none"
              data-testid="contact-message"
            />
          </label>
          <button type="submit" disabled={sending} className="btn-solid" data-testid="contact-submit">
            {sending ? "Sending…" : "Send"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Contact;
